<template>

    <form ref="instituicaoensino-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-6">
                <label for="tipoInstituicaoParceriaId">Tipo de Parceria CNA na Escola</label>
                <select v-select="{ dataitem: 'TipoInstituicaoParceria', default: 'Selecione' }" v-model="model.tipoInstituicaoParceriaId" class="form-control" name="tipoInstituicaoParceriaId"></select>
            </div>
            <div class="form-group col-md-3">
                <label for="CodigoMicrosiga">Franquia CNA</label>
                <input type="text" class="form-control" name="nomeEscola" placeholder="" disabled v-model="model.empresa.pessoaEscola.escola.nomeEscola" />
            </div>
            <div class="form-group col-md-3">
                <label for="CodigoMicrosiga">Código Microsiga</label>
                <input type="text" class="form-control" name="CodigoMicrosiga" placeholder="" disabled v-model="model.codigoMicrosiga" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="inscricaoEstadual">Nome da Instituição</label>
                <input type="text" class="form-control" name="Nome" placeholder="Nome da instituição de Ensino" v-model="model.empresa.pessoaEscola.nome" />
            </div>
            <div class="form-group col-md-6">
                <label for="RazaoSocial">Razão Social</label>
                <input type="text" class="form-control" name="RazaoSocial" placeholder="Razão Social da instituição de Ensino" v-model="model.empresa.pessoaEscola.apelido" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="CNPJ">CNPJ</label>
                <input type="text" maxlength="18" disabled v-mask="mask_cnpj" class="form-control" name="CNPJ" placeholder="CNPJ da Instituição Ensino" v-model="model.empresa.pessoaEscola.cpF_CNPJ" />
            </div>
            <div class="form-group col-md-6">
                <label for="IE">Inscrição Estadual</label>
                <input type="text" maxlength="18" class="form-control" name="IE" placeholder="I.E da Instituição Ensino" v-model="model.empresa.pessoaEscola.rG_IE" />
                <figcaption class="figure-caption">Se o campo for deixado em branco, o sistema assumirá que se trata de empresa "Isenta"</figcaption>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="tipoContratoInstituicaoEnsinoId">Tipo de Contrato Instituição Ensino</label>
                <select @change="alteraValorPermiteCompraAutomatica()" v-select="{ dataitem: 'TipoContratoInstituicaoEnsino', default: 'Selecione' }" v-model="model.tipoContratoInstituicaoEnsinoId" class="form-control" name="tipoContratoInstituicaoEnsinoId"></select>
            </div>
            <div class="form-group col-md-6">
                <label for="quantidadeAlunosPrevista">Quantidade de Alunos</label>
                <input type="number" class="form-control" name="quantidadeAlunosPrevista" placeholder="Quantidade de alunos prevista" v-model="model.quantidadeAlunosPrevista" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6" v-show="model.tipoContratoInstituicaoEnsinoId == 3">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-4" v-show="model.tipoContratoInstituicaoEnsinoId == 3">
                <!--<div class="clearfix">&nbsp;</div>-->
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="permiteCompraAutomatica" class="custom-control-input" v-model="model.permiteCompraAutomatica">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Permite Compra Automática?</span>
                </label>
                <!--<div class="clearfix">&nbsp;</div>-->
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" @click="permiteBoleto()" name="permiteBoleto" class="custom-control-input" v-model="model.permiteBoleto">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Permite Boleto?</span>
                </label>
            </div>
            <div class="form-group col-md-4" v-show="model.permiteBoleto == true">
                <label for="numeroParcelaBoleto">NumeroParcelaBoleto</label>
                <input type="text" class="form-control" name="numeroParcelaBoleto" placeholder="NumeroParcelaBoleto" v-model="model.numeroParcelaBoleto" />
            </div>
            <div class="form-group col-md-4" v-show="model.permiteBoleto == true">
                <label for="numeroParcelaCartao">NumeroParcelaCartao</label>
                <input type="text" class="form-control" name="numeroParcelaCartao" placeholder="NumeroParcelaCartao" v-model="model.numeroParcelaCartao" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="dataInicioParceria">DataInicioParceria</label>
                <input type="text" v-datepicker class="form-control" name="dataInicioParceria" v-model="model.dataInicioParceria" />
            </div>
            <div class="form-group col-md-6">
                <label for="dataTerminoParceria">DataTerminoParceria</label>
                <input type="text" v-datepicker class="form-control" name="dataTerminoParceria" v-model="model.dataTerminoParceria" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="contato">Contato</label>
                <input type="text" class="form-control" name="contato" placeholder="Contato" v-model="model.contato" />
            </div>

            <div class="form-group col-md-6">
                <label for="email">E-mail</label>
                <input type="text" class="form-control" name="email" placeholder="E-mail da Instituição de Ensino" v-model="model.empresa.pessoaEscola.email" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="telefone">Telefone</label>
                <input type="text" class="form-control" v-mask="mask_telddd" name="telefone" maxlength="13" placeholder="Telefone" v-model="model.empresa.pessoaEscola.telefone" />
            </div>

            <div class="form-group col-md-4">
                <label for="celular">Celular</label>
                <input type="text" class="form-control" v-mask="mask_celddd" maxlength="14" name="celular" placeholder="Celular" v-model="model.empresa.pessoaEscola.celular" />
            </div>
            <div class="form-group col-md-4">
                <label for="cep">CEP</label>
                <input type="text" class="form-control" name="cep" v-mask="mask_cep" maxlength="15" placeholder="CEP" v-model="model.empresa.pessoaEscola.endereco.cep" />
            </div>

        </div>
        <div class="row">

            <div class="form-group col-md-9">
                <label for="rua">Logradouro</label>
                <input type="text" class="form-control" name="rua" placeholder="Endereço" v-model="model.empresa.pessoaEscola.endereco.rua" />
            </div>


            <div class="form-group col-md-3">
                <label for="numero">Número</label>
                <input class="form-control" type="number" min="0" name="numero" placeholder="Número" v-model="model.empresa.pessoaEscola.endereco.numero" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="complemento">Complemento</label>
                <input type="text" class="form-control" name="complemento" placeholder="Complemento" v-model="model.empresa.pessoaEscola.endereco.complemento" />
            </div>

            <div class="form-group col-md-4">
                <label for="bairro">Bairro</label>
                <input type="text" class="form-control" name="bairro" placeholder="Bairro" v-model="model.empresa.pessoaEscola.endereco.bairro" />
            </div>
            <div class="form-group col-md-4">
                <label for="cidade">Cidade</label>
                <input type="text" class="form-control" name="cidade" placeholder="Cidade" v-model="model.empresa.pessoaEscola.endereco.cidade" />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="estadoId">Estado</label>
                <select v-select="{ dataitem: 'Estado', default: 'Selecione' }" v-model="model.empresa.pessoaEscola.endereco.estadoId" class="form-control" name="estadoId"></select>
            </div>
            <div class="form-group col-md-3">
                <label>Situação de Parceira</label>
                <div class="form-group">

                    <label class="custom-control custom-radio" style="float: left;margin-right:2px;">
                        <input type="radio" name="ativo" v-model="model.situacaoInstituicaoEnsinoId" value="1" class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description"> Ativo</span>
                    </label>
                    <label class="custom-control custom-radio" style="float: left;margin-right:2px;">
                        <input type="radio" name="ativo" v-model="model.situacaoInstituicaoEnsinoId" value="2" class="custom-control-input">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description"> Inativo</span>
                    </label>
                </div>
            </div>           
            <div class="form-group col-md-3">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" name="vendaCommerce" class="custom-control-input" v-model="model.vendaCommerce">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description"> Venda pelo Commerce?</span>
                    </label>               
             </div>
        </div>    

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensino-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({
            disabled: 0,
            model: {
                empresa: {
                    pessoaEscola: {
                        endereco: {},
                        escola: {},
                    },
                }

            },

            form: "instituicaoensino-form-edit",

            resources: {
                edit: 'instituicaoensino',
            },

        }),

        methods: {
            alteraValorPermiteCompraAutomatica() {
                if (this.model.tipoContratoInstituicaoEnsinoId != 3) {

                    this.model.permiteBoleto = false;
                    this.model.numeroParcelaBoleto = "";
                    this.model.numeroParcelaCartao = "";
                }

            },
            permiteBoleto() {
                if (this.model.permiteBoleto == false) {
                    this.model.numeroParcelaBoleto = "";
                    this.model.numeroParcelaCartao = "";
                }

            },
            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                if (model.empresa.pessoaEscola.cpF_CNPJ != "") {
                    model.empresa.pessoaEscola.cpF_CNPJ = model.empresa.pessoaEscola.cpF_CNPJ.replace(/(\.|\/|\-)/g, "");

                }

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ instituicaoEnsinoId: this.$route.params.id }).then(data => {

                if (data.data) this.model = data.dataList;

                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>